import { LazyLoadImage } from 'react-lazy-load-image-component';

export default LazyLoadImage;
